module.exports = __webpack_public_path__ + "img/new4.7ece86e7.png";